module.exports = __webpack_public_path__ + "static/img/Ellipse66.ba8b1ba9.png";